import {
    typeOfPatientOpt,
    typeOfTBOpt,
    lpaResultOpt,
    cultureResultOpt,
    cxrResultOpt,
    comorbidDieaseOpt,
    hivResultOpt,
    artRxOpt, cptRxOpt,
    finalOpt,
    months
} from "./options.js";

function getTypeOfTbPatient(value) {
    var result = typeOfPatientOpt.find((val) => {
        return val.id == value.type_of_patient;
    });
    return result ? result.text : "";
}
function getTypeOfTb(value) {
    var result = typeOfTBOpt.find((val) => {
        return val.id == value.type_of_tb;
    });
    return result ? result.text : "";
}
function getLpaResult(value) {
    var result = lpaResultOpt.find((val) => {
        return val.id == value.lpa_result;
    });
    return result ? result.text : "";
}
function getCultureResult(value) {
    var result = cultureResultOpt.find((val) => {
        return val.id == value.culture_result;
    });
    return result ? result.text : "";
}
function getCxrResult(value) {
    var result = cxrResultOpt.find((val) => {
        return val.id == value.cxr_result;
    });
    return result ? result.text : "";
}
function getComboidDisease(value) {
    var result = "";
    value.comorbid_diseases.map((val) => {
        result += `${comorbidDieaseOpt.find(
            (value) => value.comorbid_dieases_id == val.comorbid_diseases_id
        ).text
            },`;
    });
    return result;
}
function getHivResult(value) {
    switch (value.hiv_status) {
        case 1:
            return "No";

        case 2:
            return "Yes";

        default:
            return "";
    }
}
function getTreatmentFinish(value) {
    switch (value.treatment_finish) {
        case 1:
            return "Stop";
        case 2:
            return "Finish";
        default:
            return "On-going";
    }
}

function getSupportMonth(month) {
    var result = months.find((val) => {
        return val.value == month;
    });
    return result ? result.text : "";
}

function getSupportItem(returnObj, index, month, year, support, type) {
    var monthKey = `${type} Month ${index}`;
    var yearKey = `${type} Year ${index}`;
    var supportKey = `${type} Support ${index}`;
    var supObj = {};
    supObj[monthKey] = month;
    supObj[yearKey] = year;
    supObj[supportKey] = support;
    return { ...returnObj, ...supObj };

}

function getEnrollData(value, type, mostEnrollCount = 0) {
    var returnObj = {};
    value.map((element, index) => {
        index += 1;
        returnObj = getSupportItem(returnObj, index, getSupportMonth(element.support_month), element.support_year, element.support == 1 ? "Yes" : "No", type);
    })

    if (type == "Pre" && value.length < 2) {
        returnObj = {
            ...returnObj, ...{
                "Pre Month 2": "",
                "Pre Year 2": "",
                "Pre Support 2": "",
            }
        }
    }
    else if (type == "Enroll" && value.length < mostEnrollCount) {
        for (var i = 1; i < mostEnrollCount; i++) {
            var index = value.length + i;
            returnObj = getSupportItem(returnObj, index, "", "", "", type);
        }
    }


    return returnObj;
}


export function getCustomFields(value, mostEnrollCount) {
    return {
        ...{
            Name: value.name,
            Sex: value.sex,
            Address: value.address,
            DOB: value.dob,
            "Mono-Poly": value.mdrtb_monopoly == 1 ? "No" : value.mdrtb_monopoly == 2 ? 'Yes' : value.mdrtb_monopoly == 3? 'SG':value.mdrtb_monopoly == 4? 'MGY': '',
            "Lab Test Name": value.lab_test_name,
            "Lab Code": value.lab_code,
            "Lab Date": value.lab_date,
            "Lab Result": value.lab_result,
            "MDRTB Code": value.reg_unique_code,
            "Treatment Startdate": value.treatment_startdate,
            "Outside Township": value.outside_tsp == 1 ? "No" : "Yes",
            "Outside Township Name": value.outside_tsp == 1 ? "No" : "Yes",
            "Transfer In": value.t_in == 1 ? "No" : "Yes",
            "Transfer In Date": value.t_in == 2 ? value.t_in_date : "",
            "Transfer In Area": value.t_in == 2 ? value.t_in_type == 1 ? "Within Project" : "Outside" : "",
            "Transfer In Township": value.t_in == 2 ? value.transfer_in_township.short_code : "",
            "Type Of Patient": getTypeOfTbPatient(value),
            "Type Of TB": getTypeOfTb(value),
            "LPA Result": getLpaResult(value),
            "LPA Date": value.lpa_date,
            "Culture Date": value.culture_date,
            "Culture Result": getCultureResult(value),
            "CXR Date": value.cxr_date,
            "CXR Result": getCxrResult(value),
            "Comorbid Disease": getComboidDisease(value),
            "HIV Test": getHivResult(value),
            "HIV Date": value.hiv_status == 2 ? value.hiv_date : "",
            "HIV Result": value.hiv_status == 2 ? hivResultOpt.find((val) => val.id == value.hiv_result).text : "",
            "ART RX": value.hiv_result == 1 ? artRxOpt.find((val) => val.id == value.art_rx).text : "",
            "ART Date": value.art_rx == 2 ? value.art_rx_date : "",
            "CPT RX": value.hiv_result == 1 ? cptRxOpt.find((val) => val.id == value.cpt_rx).text : "",
            "CPT Date": value.cpt_rx == 2 ? value.cpt_rx_date : "",
            "DOTS Patient": value.is_dots_patient ? "Yes" : "No",
            "DOTS Startdate": value.is_dots_patient ? value.dots_patient.dots_startdate : "",
            Phone: value.is_dots_patient ? value.dots_patient.phone : "",
            "Body Weight": value.is_dots_patient ? value.dots_patient.body_weight : "",
            "Treatment Finish": getTreatmentFinish(value),
            "Finished Date": value.finished_date,
            "Final Outcome": value.final_outcome ? finalOpt.find((val) => val.id == value.final_outcome).text : "",
            "Outcome Date": value.final_outcome_date,
            "Issued Date": value.issue_date,
            "Pre-Enroll": value.pre_enroll == 1 ? "Yes" : "No"
        },
        ...getEnrollData(value.pre_enroll_supports, "Pre"),
        ...getEnrollData(value.enroll_supports, "Enroll", mostEnrollCount),


    }

}




